module.exports = (__webpack_require__(0))(198);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/ItemListWidget.js from dll-reference girder_lib
// module id = 217
// module chunks = 0